import { render, staticRenderFns } from "./ChatWhatsapp.vue?vue&type=template&id=18cd0805&scoped=true"
import script from "./ChatWhatsapp.vue?vue&type=script&lang=js"
export * from "./ChatWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./ChatWhatsapp.vue?vue&type=style&index=0&id=18cd0805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd0805",
  null
  
)

export default component.exports